module.exports = new __parcel__URL__("Charlie_Display-Bold_Italic.a86c301e.woff2").toString();